import { Button } from "@mui/material";
import React from "react";
import { colors } from "../../theme/theme";
import { East } from "@mui/icons-material";

export const CustomBtn = ({
  onClick,
  text,
  icon = false,
  width,
  height,
  mt,
  mb,
  secondary,
  border,
  fontSize,
  bgc,
  noClick = false,
}) => {
  return (
    <Button
      type="submit"
      variant="contained"
      sx={{
        mt: mt || 0,
        mb: mb || 0,
        width: width || "50%",
        height: height || "50px",
        cursor: noClick ? "default" : "pointer",
        background: secondary
          ? null
          : `
          linear-gradient(90deg, #F07A18 0%, #C93221 100%),
          linear-gradient(0deg, #F78419, #F78419)
        `,
        backgroundBlendMode: secondary ? null : "overlay",
        backgroundColor: secondary ? bgc || "rgba(247,132,25,0.05)" : null,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textTransform: "none",
        borderRadius: "9px",
        border: border || "none",
        fontFamily: "Mulish-SemiBold",
        color: secondary ? colors.secondary : "#fff",
        gap: 1,
        fontSize: {
          sm: "14px",
          md: "16px",
          lg: fontSize || "18px",
        },
        "&:hover": {
          background:
            "linear-gradient(0deg, #c75e0d, #c75e0d), linear-gradient(90deg, #b92b1c 0%, #801f15 100%)",
          color: "#fff",
        },
      }}
      onClick={onClick}
    >
      {text}
      {icon && <East sx={{ fontSize: "18px" }} />}
    </Button>
  );
};
